import { useEffect, useMemo, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useVerifyProgressTransferRequest } from 'academy-common-lib/features/certificate/components/progressTransfer/hooks/useProgressTransfer';
import Raven from 'raven-js';
export const useProgressTransferVerification = () => {
  const location = useLocation();
  const [isVerified, setIsVerified] = useState(false);
  const [verifyProgressTransferRequest, {
    error,
    data
  }] = useVerifyProgressTransferRequest();
  const {
    confirmSwap,
    confirmationGuid
  } = useMemo(() => {
    const searchParams = new URLSearchParams(location.search);
    return {
      confirmSwap: searchParams.get('confirmSwap'),
      confirmationGuid: searchParams.get('confirmationGuid')
    };
  }, [location.search]);
  const shouldVerify = confirmSwap === 'true' && Boolean(confirmationGuid);
  useEffect(() => {
    if (shouldVerify && confirmationGuid) {
      void verifyProgressTransferRequest({
        variables: {
          confirmationGuid
        },
        onCompleted: () => setIsVerified(true),
        onError: () => {
          Raven.captureMessage(`Certificate transfer confirmation: error swaping emails`, {
            extra: {
              confirmationGuid
            }
          });
        }
      });
    }
  }, [shouldVerify, confirmationGuid, verifyProgressTransferRequest]);
  return {
    shouldShowModal: shouldVerify,
    error,
    data,
    isVerified
  };
};